export const TYPES = {
  DESKTOP: "desktop",
  TABLET: "tablet",
  MOBILE: "mobile",
} as const

export const SMALL_MOBILE_SIZE = 560

export type WindowType = typeof TYPES[keyof typeof TYPES]
